<template>
    <app-loader></app-loader>
</template>

<script>
import Loader from "./Loader.vue";
export default {
  components: {
    appLoader: Loader
  },
  mounted() {
    if(localStorage.getItem('jwt'))
      this.$router.push({ name: "dashboard" });
    else
      this.$router.push({ name: "login" });

  }
};
</script>